import React from "react";
import { uploadCarPaper, removeCarPaper } from "../../model/car";
import { commonErr } from "../common/errors";
import ImageUpload from "../common/imageupload";
import { LoadingInline } from "../common/loading";
import { MessageBox } from "../common/messagebox";

export default class CarPaper extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			paper: {
				err: commonErr.INNIT,
			},
		};
	}
	componentDidMount() {
		this.setState({
			paper: {
				...this.state.paper,
				...this.props.paper,
			},
			carId: this.props.carId,
		});
	}

	componentWillReceiveProps(props) {
		this.setState({
			paper: {
				...this.state.paper,
				...props.paper,
			},
			carId: props.carId,
		});
	}

	handleFileInputChange = (photos) => {
		this.setState({
			paper: {
				...this.state.paper,
				err: commonErr.LOADING,
			},
		});
		uploadCarPaper(this.state.carId, this.state.paper.id, photos[0]).then((resp) => {
			var photos = [];
			if (this.state.paper.photos) {
				photos = photos.concat(this.state.paper.photos);
			}
			if (resp.data.data && resp.data.data.id) {
				photos.push(resp.data.data);
			}
			this.setState({
				paper: {
					...this.state.paper,
					err: resp.data.error,
					errMsg: resp.data.errorMessage,
					photos: photos,
				},
			});
		});
	};

	removeCarPaper = (paperId, photo) => {
		removeCarPaper(this.state.carId, paperId, photo.id).then((removeResp) => {
			if (removeResp.data.error >= commonErr.SUCCESS) {
				var photos = [];

				if (this.state.paper.photos) {
					photos = photos.concat(this.state.paper.photos);
				}
				photos = photos.filter((p) => {
					return p.id !== photo.id;
				});
				this.setState({
					paper: {
						...this.state.paper,
						photos: photos,
					},
				});
			} else {
				//err<commonErr.SUCCESS then Messagebox show errMessage
				this.setState({
					paper: {
						...this.state.paper,
						err: removeResp.data.error,
						errMsg: removeResp.data.errorMessage,
						photos: photos,
					},
				});
			}
		});
	};

	hidePaperMessageBox = () => {
		this.setState({
			paper: {
				...this.state.paper,
				err: commonErr.INNIT,
				errMsg: "",
			},
		});
	};

	render() {
		const { paper } = this.state;
		const { lineTag, spacemTag } = this.props.tag;
		return (
			<div>
				<h3 className="title">{paper.name}</h3>
				<div className="space m"></div>
				<div className="list-photos">
					<ul>
						<li>
							<a className="obj-photo has-tip" style={{ backgroundImage: `url(${paper.tip})` }}>
								<div className="ins">
									{paper.err !== commonErr.LOADING ? (
										<ImageUpload withPreview={false} onChange={this.handleFileInputChange} className="form-control" />
									) : (
										<LoadingInline />
									)}
									<MessageBox
										show={paper.err < commonErr.SUCCESS}
										hideModal={this.hidePaperMessageBox}
										message={paper.errMsg}
									/>
								</div>
							</a>
						</li>
						{paper.photos &&
							paper.photos.map((photo) => (
								<li key={photo.id}>
									<div className="obj-photo" style={{ backgroundImage: `url(${photo.url})` }}>
										<a className="func-remove" onClick={() => this.removeCarPaper(paper.id, photo)}>
											<button className="close close-modal" type="button">
												<span aria-hidden="true">×</span>
											</button>
										</a>
									</div>
								</li>
							))}
					</ul>
					{lineTag}
				</div>
				{spacemTag}
			</div>
		);
	}
}
